import { Injectable } from '@angular/core';
import { RoleEnum } from '@libs/core/api';

@Injectable({
  providedIn: 'root',
})
export class ApiFiltersService {
  getUserRoleFilter(role: RoleEnum): string {
    return `role eq '${role}'`;
  }

  getQuotesFilter(
    createdBy: number | undefined,
    createdAt: Date | undefined,
    projectTasks: number[],
    description?: string
  ): string | undefined {
    const filters: string[] = [];

    if (createdBy) {
      filters.push(`createdBy/id eq ${createdBy}`);
    }

    if (createdAt) {
      filters.push(`createdAt ge ${this.translateDateToApiFormat(createdAt)}`);
    }

    if (projectTasks && projectTasks.length > 0) {
      const projectTasksFilters = projectTasks
        .map((item) => `assigneeId eq ${item}`)
        .join(' or ');
      filters.push(`(${projectTasksFilters})`);
    }

    if (description?.trim()) {
      filters.push(
        `contains(tolower(description),'${this.escapeODataString(
          description.trim().toLowerCase()
        )}')`
      );
    }

    if (filters.length === 0) {
      return undefined;
    }

    return filters.join(' and ');
  }

  getCashFundsFilter(description?: string): string | undefined {
    const normalizedDescription = description?.trim().toLowerCase();

    if (!normalizedDescription) {
      return undefined;
    }

    const searchTerm = this.escapeODataString(normalizedDescription);

    return [
      `contains(tolower(article/description),'${searchTerm}')`,
      `contains(tolower(taskName),'${searchTerm}')`,
      `contains(tolower(subtask/name),'${searchTerm}')`,
    ].join(' or ');
  }

  private translateDateToApiFormat(date: Date): string {
    const isoFormat = date.toISOString();
    return `${isoFormat.slice(0, isoFormat.indexOf('.'))}+00:00`;
  }

  private escapeODataString(value: string): string {
    return value.replace(/'/g, "''");
  }
}
